import React, { useState, useEffect } from 'react';
import ReactDOM from 'react-dom';
import axios from 'axios';
import { Link } from 'react-router-dom';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import IconButton from '@mui/material/IconButton';
import { fetchData, deleteData, activateData, updateData, SyncData, postData, DespatchData } from '../../../apiService';
import { useAuth } from '../../../AuthContext';
import { tokenIsExpired } from '../../../authUtils';
import { Tooltip } from '@mui/material';
import ArrowForward from '@mui/icons-material/ArrowForward';
import Select from 'react-select';
import { useParams, useHistory } from 'react-router-dom';
import Modal from '@mui/material/Modal';
import { FaTimes } from 'react-icons/fa';
import Button from '@mui/material/Button';
import RefreshIcon from '@mui/icons-material/Refresh';
import * as XLSX from 'xlsx';
import CircularProgress from '@mui/material/CircularProgress';
import TablePagination from '@mui/material/TablePagination';
import TableFooter from '@mui/material/TableFooter';
import DeleteIcon from '@mui/icons-material/Delete';
import EditIcon from '@mui/icons-material/Edit';
import ActivateIcon from '@mui/icons-material/CheckCircle';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import PrintIcon from '@mui/icons-material/Print';
import InvoicePrint from './Estimate';
import NongstBillPrint from './Bill';
import AddIcon from '@mui/icons-material/Add';

function CounterSaleIndex() {
    const history = useHistory();
    const [data, setData] = useState([]);
    const [isLoading, setIsLoading] = useState(false);

    const { isAuthenticated, companyId, userId, permissions, token, logout } = useAuth();

    useEffect(() => {
        if (isAuthenticated && tokenIsExpired(token)) {
            logout();
        }
    }, [isAuthenticated, companyId, token, logout]);

    useEffect(() => {
        fetchCounterData();
        setfromdate(getFormattedStartDate());
        setToDate(getFormattedCurrentDate());
    }, []);



    const [filteredData, setFilteredData] = useState([]);
    const [fromdate, setfromdate] = useState('');
    const [toDate, setToDate] = useState('');
    const [Corderdate, setCorderdate] = useState("");
    const [orderTakenby, setOrdertakenby] = useState("");

    const [route, setroute] = useState("");
    const hasEditMasterPermission = permissions.includes('Edit Master');
    const hasDeleteMasterPermission = permissions.includes('Delete Master');


    const [searchQuery, setSearchQuery] = useState('');
    const [showSearchInput, setShowSearchInput] = useState(false);
    const [isFocused, setIsFocused] = useState(false);
    //handle search
    const handleSearch = (event) => {
        setSearchQuery(event.target.value);
    };

    const toggleSearchInput = () => {
        setShowSearchInput(!showSearchInput);
    };
    //search
    const searchfilteredData = data.filter((item) =>
        Object.values(item).some((value) =>
            String(value).toLowerCase().includes(searchQuery.toLowerCase())
        )
    );


    // Get the current date in 'YYYY-MM-DD' format
    const getFormattedCurrentDate = () => {
        const currentDate = new Date();
        return currentDate.toISOString().split('T')[0]; // Returns: YYYY-MM-DD
    };

    // Get the first day of the current month
    const getFormattedStartDate = () => {
        const today = new Date();
        const year = today.getFullYear();
        const month = String(today.getMonth() + 1).padStart(2, '0');
        return `${year}-${month}-01`; // First day of the month
    };

    // Get the last day of the current month
    const getFormattedEndDate = () => {
        const today = new Date();
        const year = today.getFullYear();
        const month = today.getMonth() + 1;
        const lastDay = new Date(year, month, 0).getDate(); // Get last day of month
        return `${year}-${String(month).padStart(2, '0')}-${lastDay}`;
    };

    // Handle From Date Change
    const handleFromDateChange = (e) => {
        setfromdate(e.target.value);
    };

    // Handle To Date Change
    const handleToDateChange = (e) => {
        setToDate(e.target.value);
    };


    const handleRefreshClick = () => {

        fetchCounterData();

    };
    const [page, setPage] = useState(0); // Current page
    const [rowsPerPage, setRowsPerPage] = useState(15); // Rows per page

    // Define initial column order
    const [columnOrder, setColumnOrder] = useState([
        'Sl.No', 'Sale Type', 'Customer Name', 'Invoice Date', 'Bill No', 'Bill Amount', 'Paid Amount', 'Balance Amount', 'Payment Mode', 'Item Count', 'Remark'
    ]);
    // Process and paginate the data
    const processedData = searchfilteredData.slice(
        page * rowsPerPage,
        page * rowsPerPage + rowsPerPage
    );


    const fetchCounterData = async () => {
        try {
            const response = await fetchData('CounterSaleApi', `/${fromdate}/${toDate}/${companyId}`, token);

            if (response.responseCode === '1111') {
                const dataArray = response.response_data.map(item => {
                    let paymentMode = [];

                    if (item.CashAmount > 0) paymentMode.push("Cash");
                    if (item.UPIAmount > 0) paymentMode.push("UPI");
                    if (item.CardAmount > 0) paymentMode.push("Card");
                    if (item.BankTransferAmount > 0) paymentMode.push("Bank Transfer");  // Add additional payment modes here

                    return {
                        ...item,
                        PaymentMode: paymentMode.join(", ") // Combine multiple payment modes as a string
                    };
                });

                setData(dataArray);
            } else {
                console.error('Unexpected response code:', response.responseCode);
            }
        } catch (error) {
            console.error('Error fetching Sale Details:', error);
        }
    };

    const handleSaleOrderPrint = async (CounterSaleid) => {
        try {
            // Fetch data
            const response = await fetchData('CounterSaleApi', `/CounterSalePrint/${CounterSaleid}`, token);
            const labelData = Array.isArray(response.response_data) ? response.response_data : [response.response_data];

            // Create iframe
            const iframe = document.createElement('iframe');
            iframe.style.display = 'none';
            document.body.appendChild(iframe);

            // Write component content to iframe
            const iframeDocument = iframe.contentDocument || iframe.contentWindow.document;
            iframeDocument.write('<html><head><style>@media print { header, footer { display: none !important; } }</style></head><body>');

            ReactDOM.render(
                labelData[0].CounterSalePrint.IsGST === true ? (
                    <InvoicePrint labelData={labelData} onClose={() => document.body.removeChild(iframe)} />
                ) : (
                    <NongstBillPrint labelData={labelData} onClose={() => document.body.removeChild(iframe)} />
                ),
                iframeDocument.body
            );


            iframeDocument.write('</body></html>');
            iframeDocument.close();

            // Print the content
            iframe.contentWindow.print();


            try {
                await SyncData('CounterSaleApi', `${CounterSaleid}`, token);
            } catch (updateError) {
                console.error('Error updating record:', updateError);
            }
        } catch (error) {
            console.error('Error printing Estimate:', error);
        }


    };
    // Handle page change
    const handlePageChange = (event, newPage) => {
        setPage(newPage);
    };

    // Handle rows per page change
    const handleRowsPerPageChange = (event) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0); // Reset to the first page
    };

    // Function to handle drag start
    const handleDragStart = (e, index) => {
        e.dataTransfer.setData('columnIndex', index);
    };

    // Function to handle drag over
    const handleDragOver = (e) => {
        e.preventDefault(); // Allow drop
    };
    // Function to handle drop
    const handleDrop = (e, index) => {
        const draggedIndex = e.dataTransfer.getData('columnIndex');
        if (draggedIndex !== index) {
            const newOrder = [...columnOrder];
            // Swap columns
            [newOrder[draggedIndex], newOrder[index]] = [newOrder[index], newOrder[draggedIndex]];
            setColumnOrder(newOrder);
        }
    };

    const openConfirmDialog = (itemId) => {
        setDeleteItemId(itemId);
        setConfirmDialogOpen(true);
      };
    
      const closeConfirmDialog = () => {
        setDeleteItemId(null);
        setConfirmDialogOpen(false);
      };
    
    

    const [deleteItemId, setDeleteItemId] = useState(null);
    const [confirmDialogOpen, setConfirmDialogOpen] = useState(false);

    // const handleDelete = async (deleteItemId) => {
    //     deleteData('CounterSaleApi', `${deleteItemId}`, token)
    //         .then((response) => {
    //             console.log('Record deleted successfully:', response.data);
    //             setDeleteItemId(null);
    //             setConfirmDialogOpen(false);
    //             // Refresh the data after deletion

    //         })
    //         .catch((error) => {
    //             console.error('Error deleting record:', error);
    //         });
    // };
 const handleDelete = async () => {
    deleteData('CounterSaleApi', `${deleteItemId}`, token)
      .then((response) => {
        console.log('Record deleted successfully');
        setDeleteItemId(null);
        setConfirmDialogOpen(false);
       
      })
      .catch((error) => {
        console.error('Error deleting record:', error);
      });
  };

    const [editedRouteSequenceNo, setEditedRouteSequenceNo] = useState(null);
    const [editItemId, setEditItemId] = useState(null);

    const handleActivate = (itemId) => {
        activateData('CounterSaleApi', `${itemId}`, token)
            .then((response) => {
                // fetchtableData();
            })
            .catch((error) => {
                // Handle errors for the activation request
            });
    };

    return (
        <div className="container mt-2 mx-auto" style={{ maxWidth: '97%' }}>
            <div className='mb-2 flex justify-between'>
                <h6 className='block uppercase tracking-wide text-black productHead flex-grow linkcolor' style={{ fontFamily: 'Georgia, Cambria, "Times New Roman", Times, serif' }}> Counter Sale</h6>

                <div className="flex justify-end">
                    <div style={{ marginRight: '10px', marginTop: '-10px', }}>
                        <input
                            className="shadow text-gray-700 leading-tight"
                            type="text"
                            placeholder="Search..."
                            value={searchQuery}
                            onChange={handleSearch}
                            onFocus={() => setIsFocused(true)}
                            onBlur={() => setIsFocused(false)}
                            style={{
                                width: isFocused ? '300px' : '200px',
                                height: '40px',
                                border: '1px solid #ccc',
                                borderRadius: '15px',
                                padding: '0 20px',
                                transition: 'width 0.4s ease-in-out, border-color 0.3s ease-in-out',
                                outline: 'none',
                                borderColor: isFocused ? 'darkcyan' : '#ccc',
                                boxShadow: isFocused ? '0 4px 8px rgba(0, 0, 0, 0.2)' : 'none',
                                marginTop: '20px'
                            }}
                        />
                    </div>
                </div>

                <div className="w-1/8 mr-2">
                    <label style={{ display: 'block', color: 'black', fontSize: '12px' }} htmlFor="fromDate">
                        FROM DATE
                    </label>
                    <input
                        className="shadow appearance-none  rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                        type="date" value={fromdate} onChange={handleFromDateChange}
                        style={{
                            shadow: 'appearance-none',
                            border: 'rounded', width: '100%',
                            paddingY: '2', paddingX: '3',
                            color: 'gray-700', leadingTight: true,
                            focus: { color: 'gray-600', shadow: 'outline' }
                        }}
                    />
                </div>

                <div className="w-1/8 mr-2">
                    <label style={{
                        display: 'block', color: 'black', fontSize: '12px'
                    }} htmlFor="toDate">
                        TO DATE
                    </label>
                    <input
                        className="shadow appearance-none  rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                        type="date" value={toDate} onChange={handleToDateChange}
                        style={{
                            shadow: 'appearance-none',
                            border: 'rounded', width: '100%',
                            paddingY: '2', paddingX: '3',
                            color: 'gray-700', leadingTight: true,
                            focus: { color: 'gray-600', shadow: 'outline' }
                        }}
                    />
                </div>

                <Tooltip title="Create CounterSale ">
                    <Link to="/CounterSaleCreate" className="inline-block">

                        <Button
                            style={{
                                backgroundColor: 'darkcyan',
                                color: 'white',
                                height: '36px',
                                marginTop: '20px',
                                marginLeft: '5px'

                            }}
                            onClick={handleRefreshClick}
                            className="linkcolor"
                        >
                            Create
                        </Button>
                    </Link>
                </Tooltip>
                <Button
                    style={{
                        backgroundColor: '#C9E9D2',
                        color: 'black',
                        height: '36px',
                        marginTop: '20px',
                        marginLeft: '5px'

                    }}
                    onClick={handleRefreshClick}
                    className="linkcolor"
                >
                    <span>Refresh</span>
                </Button>
            </div>

            <div className='mb-2 flex' style={{ maxHeight: '520px', overflowY: 'auto' }}>

                <TableContainer component={Paper}>
                    <Table>
                        <TableHead sx={{
                            backgroundColor: '#36454F', width: '1500px', position: 'sticky', // Makes the header sticky
                            top: 0,             // Locks it to the top
                            zIndex: 1,
                        }}>
                            <TableRow>
                                <TableCell sx={{ borderBottom: '1px solid #F5F5F5', fontWeight: 'bolder', fontSize: '14px', padding: '7px', color: 'whitesmoke', textAlign: 'left', width: '1%' }}>Sl.No</TableCell>
                                <TableCell sx={{ borderBottom: '1px solid #F5F5F5', fontWeight: 'bolder', fontSize: '14px', padding: '7px', color: 'whitesmoke', textAlign: 'left', width: '10%' }}>Type</TableCell>
                                <TableCell sx={{ borderBottom: '1px solid #F5F5F5', fontWeight: 'bolder', fontSize: '14px', padding: '7px', color: 'whitesmoke', textAlign: 'left', width: '16%' }}> Name</TableCell>
                                <TableCell sx={{ borderBottom: '1px solid #F5F5F5', fontWeight: 'bolder', fontSize: '14px', padding: '7px', color: 'whitesmoke', textAlign: 'left', width: '7%' }}>Bill Date</TableCell>
                                <TableCell sx={{ borderBottom: '1px solid #F5F5F5', fontWeight: 'bolder', fontSize: '14px', padding: '7px', color: 'whitesmoke', textAlign: 'left', width: '9%' }}>Bill No</TableCell>
                                <TableCell sx={{ borderBottom: '1px solid #F5F5F5', fontWeight: 'bolder', fontSize: '14px', padding: '7px', color: 'whitesmoke', textAlign: 'left', width: '9%' }}>Bill Amount</TableCell>
                                <TableCell sx={{ borderBottom: '1px solid #F5F5F5', fontWeight: 'bolder', fontSize: '14px', padding: '7px', color: 'whitesmoke', textAlign: 'left', width: '7%' }}>Paid </TableCell>
                                <TableCell sx={{ borderBottom: '1px solid #F5F5F5', fontWeight: 'bolder', fontSize: '14px', padding: '7px', color: 'whitesmoke', textAlign: 'left', width: '7%' }}>Balance</TableCell>
                                <TableCell sx={{ borderBottom: '1px solid #F5F5F5', fontWeight: 'bolder', fontSize: '14px', padding: '7px', color: 'whitesmoke', textAlign: 'center', width: '7%' }}>Pay Option</TableCell>
                                <TableCell sx={{ borderBottom: '1px solid #F5F5F5', fontWeight: 'bolder', fontSize: '14px', padding: '7px', color: 'whitesmoke', textAlign: 'center', width: '7%' }}>Item Count</TableCell>
                                {/* <TableCell sx={{ borderBottom: '1px solid #F5F5F5', fontWeight: 'bolder', fontSize: '14px', padding: '7px', color: 'whitesmoke', textAlign: 'center', width: '15%' }}>Remark</TableCell> */}
                                <TableCell sx={{ borderBottom: '1px solid #F5F5F5', fontWeight: 'bolder', fontSize: '14px', padding: '7px', color: 'whitesmoke', textAlign: 'center', width: '20%' }}>Actions</TableCell>

                            </TableRow>
                        </TableHead>
                        <TableBody sx={{ backgroundColor: '#F5F5F7' }}>
                            {processedData.map((item, index) => (
                                <TableRow
                                    key={item.id}
                                    className={item.customername === 'Total' ? 'highlighted-row' : ''}
                                    sx={{
                                        padding: '5px',
                                        height: '42px',
                                        backgroundColor: item.customername === 'Total' ? '#C7B7A3' : 'transparent',

                                    }}
                                >
                                    <TableCell sx={{ borderBottom: '1px solid #F5F5F5', color: 'Black', padding: '2px', textAlign: 'left', fontSize: '13px', width: '1%' }}>{index + 1}</TableCell>
                                    <TableCell sx={{ borderBottom: '1px solid #F5F5F5', color: 'Black', padding: '2px', textAlign: 'left', fontSize: '13px', width: '5%' }}>{item.route}</TableCell>
                                    <TableCell sx={{ borderBottom: '1px solid #F5F5F5', color: 'Black', padding: '2px', textAlign: 'left', fontSize: '13px', width: '15%' }}>{item.cust}_{item.AddressLine}</TableCell>
                                    <TableCell sx={{ borderBottom: '1px solid #F5F5F5', color: 'Black', padding: '2px', textAlign: 'left', fontSize: '13px', width: '7%' }}>{item.InvoiceDate ? new Date(item.InvoiceDate).toLocaleDateString('en-GB') : ''}</TableCell>
                                    <TableCell sx={{ borderBottom: '1px solid #F5F5F5', color: 'Black', padding: '2px', textAlign: 'left', fontSize: '13px', width: '7%' }}>{item.BillPrefix}-{item.InvoiceNo}/{item.FinYear}</TableCell>
                                    <TableCell sx={{ borderBottom: '1px solid #F5F5F5', color: 'Black', padding: '2px', textAlign: 'center', fontSize: '13px', width: '7%' }}>{typeof item.TotalAmount === 'number' ? item.TotalAmount.toFixed(2) : '00'}</TableCell>
                                    <TableCell sx={{ borderBottom: '1px solid #F5F5F5', color: 'Black', padding: '2px', textAlign: 'center', fontSize: '13px', width: '7%' }}>{typeof item.PaidAmount === 'number' ? item.PaidAmount.toFixed(2) : '00'}</TableCell>
                                    <TableCell sx={{ borderBottom: '1px solid #F5F5F5', color: 'Black', padding: '2px', textAlign: 'center', fontSize: '13px', width: '7%' }}> {typeof item.BalanceAmount === 'number' ? item.BalanceAmount.toFixed(2) : '00'}</TableCell>
                                    <TableCell sx={{ borderBottom: '1px solid #F5F5F5', color: 'Black', padding: '2px', textAlign: 'center', fontSize: '13px', width: '7%' }}>{item.PaymentMode}</TableCell>
                                    <TableCell sx={{ borderBottom: '1px solid #F5F5F5', color: 'Black', padding: '2px', textAlign: 'center', fontSize: '13px', width: '15%' }}>{item.itemcount}</TableCell>
                                    {/* <TableCell sx={{ borderBottom: '1px solid #F5F5F5', color: 'Black', padding: '2px', textAlign: 'center', fontSize: '13px', width: '15%' }}>{item.remark}</TableCell> */}
                                    <TableCell sx={{ borderBottom: '1px solid #FFE1E2', fontSize: '14px', padding: '2px' }}>
                                        {hasEditMasterPermission && (
                                            <Link to={`/CounterSaleEdit/${item.Id}`}>
                                                <IconButton>
                                                    <EditIcon style={{ color: 'blueviolet', height: '20px' }} />
                                                </IconButton>
                                            </Link>
                                        )}
                                        {hasDeleteMasterPermission && (
                                            <IconButton onClick={() => (item.IsActive ? openConfirmDialog(item.Id) : handleActivate(item.Id))}>
                                                {item.IsActive ? <DeleteIcon style={{ color: 'brown', height: '20px' }} /> : <ActivateIcon />}
                                            </IconButton>
                                        )}
                                        <Tooltip title="Print Bill">
                                            <Button
                                                onClick={() => handleSaleOrderPrint(item.Id)}
                                                style={{
                                                    //backgroundColor: 'orange',
                                                    color: 'orange',
                                                    height: '25px',
                                                }}
                                            >
                                                <PrintIcon /> {/* Replace "Print" with the Print icon */}
                                            </Button>
                                        </Tooltip>

                                    </TableCell>

                                </TableRow>

                            ))}
                        </TableBody>
                        <Dialog
                open={confirmDialogOpen}
                onClose={closeConfirmDialog}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
              >
                <DialogTitle id="alert-dialog-title">{"Delete Record?"}</DialogTitle>
                <DialogContent>
                  <DialogContentText id="alert-dialog-description">
                    Are you sure you want to delete this record?
                  </DialogContentText>
                </DialogContent>
                <DialogActions>
                  <button
                    onClick={closeConfirmDialog}
                    style={{
                      backgroundColor: '#dc3545',
                      color: '#ffffff',
                      border: '1px solid #dc3545',
                      borderRadius: '4px',
                      padding: '8px 16px',
                      cursor: 'pointer',
                      marginRight: '8px',
                    }}
                  >
                    Cancel
                  </button>
                  <button
                    onClick={handleDelete}
                    style={{
                      backgroundColor: '#28a745',
                      color: '#ffffff',
                      border: '1px solid #28a745',
                      borderRadius: '4px',
                      padding: '8px 16px',
                      cursor: 'pointer',
                    }}
                  >
                    Confirm
                  </button>
                </DialogActions>
              </Dialog>
                        <TableFooter style={{ padding: '5px' }}>
                            <TableRow>
                                <TablePagination
                                    rowsPerPageOptions={[15, 25, 50, 100]}
                                    count={searchfilteredData.length}
                                    rowsPerPage={rowsPerPage}
                                    page={page}
                                    onPageChange={handlePageChange}
                                    onRowsPerPageChange={handleRowsPerPageChange}
                                />
                            </TableRow>
                        </TableFooter>
                    </Table>
                </TableContainer>
            </div>

        </div>
    );
}

export default CounterSaleIndex;